import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { SituationSection } from '../components/SituationSection';
import { ChecklistSection } from '../components/ChecklistSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { ProcessSection } from '../components/ProcessSection';
import { FounderSection } from '../components/FounderSection';
import { FaqSection } from '../components/FaqSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { useScrollToAnchor } from '../hooks/useScrollToAnchor';
import { faq } from '../data/faq';
import { contact } from '../data/contact';
export function HomePage() {
  useScrollToAnchor();

  // FAQ schema is generated from the visible FAQ so both always stay in sync
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': `${contact.siteUrl}#faq`,
      mainEntity: faq.map(item => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      }))
    };
    document.querySelectorAll('script[data-faq-schema]').forEach(el => el.remove());
    const tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.setAttribute('data-faq-schema', 'true');
    tag.textContent = JSON.stringify(schema);
    document.head.appendChild(tag);
    return () => tag.remove();
  }, []);
  return <div className="min-h-screen w-full bg-[#0a0e1a]" data-id="element-280" data-mp="20qp4qmt7efuk">
      <SEO title="Beste Close CRM Agentur finden – Vergleich 2026 | CRM Kraft" description="Close CRM Agentur gesucht? 6 Kriterien aus 150+ Implementierungen, ehrlicher Agentur-Vergleich, Kosten & FAQ. Jetzt kostenlos beraten lassen." canonical={contact.siteUrl} data-id="element-281" data-mp="20p4a6x6w2wwp" />
      <Navigation data-id="element-282" data-mp="3h3nstr37lez1" />
      <main data-id="element-283" data-mp="3h71susoehc3b">
        <Hero data-id="element-284" data-mp="3h6s39679p6y5" />
        <SituationSection data-id="element-285" data-mp="2rgjkuo2vo2y8" />
        <ChecklistSection data-id="element-286" data-mp="2rfs0yain7tns" />
        <ComparisonSection data-id="element-287" data-mp="2reyqozkh6m0w" />
        <ProcessSection data-id="element-288" data-mp="2mhqj1swye0dw" />
        <FounderSection data-id="element-289" data-mp="2mi8cyiw582in" />
        <FaqSection data-id="element-290" data-mp="2mgx9ylaiuysl" />
        <CTASection data-id="element-291" data-mp="2mhgtg6ftlv8q" />
      </main>
      <Footer data-id="element-292" data-mp="31epn56sljb3m" />
    </div>;
}